import { z } from 'zod';

export const errorCodes = [
  'bad_request',
  'validation_error',
  'unauthorized',
  'forbidden',
  'csrf_invalid',
  'not_found',
  'conflict',
  'idempotency_conflict',
  'rate_limited',
  'file_too_large',
  'unsupported_file',
  'not_sliced',
  'corrupt_file',
  'last_admin',
  'captcha_required',
  'captcha_invalid',
  'two_factor_required',
  'two_factor_invalid',
  'internal_error',
] as const;

export const ErrorCode = z.enum(errorCodes);
export type ErrorCode = z.infer<typeof ErrorCode>;

/** The one error shape every endpoint returns. */
export const ErrorResponse = z
  .object({
    error: z.object({
      code: ErrorCode,
      message: z.string(),
      details: z.unknown().optional(),
    }),
  })
  .meta({
    id: 'ErrorResponse',
    example: { error: { code: 'not_found', message: 'User not found' } },
  });
export type ErrorResponse = z.infer<typeof ErrorResponse>;
